import { gql } from 'apollo-boost';

export const UNDELETE_DANCER = gql`
  mutation DancerUndelete($dancerId: ID!) {
    dancer_undelete(input: { id: $dancerId }) {
      clientMutationId
      dancer {
        deleted
      }
    }
  }
`;